import React, { useCallback, useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ButtonGroup,
  Container,
  Col,
  Form,
  Row,
  Spinner,
  Modal,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import { createReactEditorJS } from "react-editor-js";
import { EDITOR_JS_TOOLS } from "../../../components/OnBoarding_OffBoarding/tools";
import info from "../../../images/info.svg";

import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/OnBoarding_OffBoarding/sidebar_On_Off_Boarding";

import {
  getBienvenida,
  saveBienvenida,
  editBienvenida,
  deleteBienvenida,
} from "../../../redux/on&offBoarning/Mantenimientos/bienvenida/actions";

import messages from "../../../redux/messages";

const ReactEditorJS = createReactEditorJS();

const MantBienvenida = (props) => {
  const [show, setShow] = useState(false);
  const [carta, setCarta] = useState({});
  const [edit, setEdit] = useState(false);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

  const editorCore = useRef(null);
  const dispatch = useDispatch();

  const data = useSelector((store) => store.bienvenida.bienvenida);
  const loading = useSelector((store) => store.bienvenida.loading);
  const saveLoading = useSelector((store) => store.bienvenida.saveLoading);

  useEffect(() => {
    dispatch(getBienvenida({}));
  }, [dispatch]);

  useEffect(() => {
    if (
      data &&
      !isEmptyObject(data) &&
      data[0] &&
      data[0].texto_json &&
      data[0].texto_json.length > 0
    ) {
      setEdit(true);
    } else if (
      data &&
      !isEmptyObject(data) &&
      data.texto_json &&
      data.texto_json.length > 0
    ) {
      setEdit(true);
    } else {
      setEdit(false);
    }
  }, [data]);

  useEffect(() => {
    if (!isEmptyObject(carta)) {
      if (edit) {
        onEdit();
      } else {
        onSubmit();
      }
    }
  }, [carta]);

  const handleInitialize = useCallback((instance) => {
    editorCore.current = instance;
  }, []);

  const handleSave = async () => {
    const savedData = await editorCore.current.save();
    const dataCarta = { texto_json: savedData.blocks };
    setCarta(dataCarta);
  };
  const onSubmit = () => {
    dispatch(saveBienvenida(carta));
  };

  const onEdit = () => {
    if (data && data[0] && data[0].id) {
      dispatch(editBienvenida(data[0].id, carta));
    } else {
      dispatch(editBienvenida(data.id, carta));
    }
  };

  const onDelete = () => {
    if (data && data[0] && data[0].id) {
      if (window.confirm(messages.preguntaEliminar)) {
        dispatch(deleteBienvenida(data[0].id));
        window.alert("Se borro este archivo");
      }
    } else {
      if (window.confirm(messages.preguntaEliminar)) {
        dispatch(deleteBienvenida(data.id));
        window.alert("Se borro este archivo");
      }
    }
  };
  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Mantenimiento de Carta de Bienvenida
            </h6>
            <Form
            // onSubmit={onSearch}
            >
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col xs="auto">
                  {loading || saveLoading ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : !edit ? (
                    <>
                      <ButtonGroup>
                        <OverlayTrigger
                          placement="left"
                          overlay={
                            <Tooltip {...props}>Información de uso</Tooltip>
                          }
                        >
                          <Button
                            variant="primary"
                            size="sm"
                            className="btn rounded mr-1"
                            onClick={() => setShowModalInfo(true)}
                          >
                            <i className="material-icons">info</i>
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip {...props}>
                              Guardar la carta de bienvenida
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="primary"
                            size="sm"
                            className="btn rounded"
                            onClick={handleSave}
                          >
                            Guardar
                          </Button>
                        </OverlayTrigger>
                      </ButtonGroup>
                    </>
                  ) : (
                    <>
                      <ButtonGroup>
                        <OverlayTrigger
                          placement="left"
                          overlay={
                            <Tooltip {...props}>Información de uso</Tooltip>
                          }
                        >
                          <Button
                            variant="primary"
                            size="sm"
                            className="btn rounded mr-1"
                            onClick={() => setShowModalInfo(true)}
                          >
                            <i className="material-icons">info</i>
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip {...props}>
                              Guardar modificación de carta
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="primary"
                            size="sm"
                            className="btn rounded mr-1"
                            onClick={handleSave}
                          >
                            Modificar
                          </Button>
                        </OverlayTrigger>
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip {...props}>
                              Elimininar carta de bienvenida
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="primary"
                            size="sm"
                            className="btn rounded mr-1"
                            onClick={onDelete}
                          >
                            <i className="material-icons">delete</i>
                          </Button>
                        </OverlayTrigger>
                      </ButtonGroup>
                    </>
                  )}
                </Col>
              </Row>
            </Form>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Container fluid>
            <div
              className="
                      flex-wrap 
                      justify-content-center 
                      align-items-center 
                      p-3 
                      mb-5 
                      bg-white 
                      "
            >
              <Row>
                <Col
                  className="shadow-sm mb-5 ml-auto mr-auto p-3 bg-white rounded"
                  style={{ border: "1px solid #ced4da" }}
                  xs="10"
                  sm="10"
                  md="9"
                  lg="9"
                  xl="9"
                >
                  {loading || saveLoading ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : (
                    <ReactEditorJS
                      onInitialize={handleInitialize}
                      defaultValue={
                        !isEmptyObject(data)
                          ? data &&
                            data[0] &&
                            data[0].texto_json &&
                            data[0].texto_json.length > 0
                            ? { blocks: data[0].texto_json }
                            : { blocks: data.texto_json }
                          : null
                      }
                      tools={EDITOR_JS_TOOLS}
                    />
                  )}
                </Col>
              </Row>
            </div>
          </Container>
        </Container>
        <Modal show={showModalInfo} onHide={() => setShowModalInfo(false)}>
          <Modal.Body className="d-flex flex-wrap justify-content-center align-items-center text-justify">
            <Col>
              <Col className="d-flex flex-wrap justify-content-center align-items-center text-justify ">
                <img src={info} alt="Info" />
              </Col>
              <Col className="d-flex flex-wrap justify-content-center align-items-center text-justify">
                <Modal.Title>Información</Modal.Title>
              </Col>
              <Col
                className="shadow-sm rounded p-3 mt-2"
                style={{ border: "1px solid #ced4da" }}
              >
                <span>
                  <b>Variables Comodines:</b>
                </span>
                <br />
                <ul>
                  <li>
                    <b>@compania</b> (Variable para descripción de la
                    organización)
                  </li>
                  <li>
                    <b>@fecha</b> (Fecha de entrega de la carta)
                  </li>
                  <li>
                    <b>@nombre_empleado</b> (Nombre del empleado al que va
                    dirigido la carta)
                  </li>
                  <li>
                    <b>@nombre_jefe</b> (Nombre del Jefe Inmediato)
                  </li>
                  <li>
                    <b>@nombre_puesto</b> (Puesto del Jefe Inmediato)
                  </li>
                </ul>
                <span>
                  <b>Nota:</b>
                </span>
                <br />
                <ol>
                  <li>
                    Solo se podrán utilizar las variables comodines mencionadas
                    anteriormente.
                  </li>

                  <li>
                    Debera escribir la variable comodin tal como aparece en la
                    lista en la parte superior.
                    <br />
                    Ejemplo: @compania
                  </li>
                  <li>
                    Debera esperar que termine de cargar la carta antes de
                    presionar el boton de modificar.
                  </li>
                </ol>
              </Col>
            </Col>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

function isEmptyObject(obj) {
  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      return false;
    }
  }

  return true;
}

export default MantBienvenida;
